import { fetchAssignedPartners, putAssignedPartners } from '@/api/admin';
import type { IAdminUserDetail, IAssignedPartner } from '@/entities/admin-user.entity';
import { useCallback, useEffect, useState } from 'react';
import { toast } from 'sonner';
import UserAssignmentSection, { type AssignmentItem } from './user-assignment-section';

interface WorkerPartnersSectionProps {
	user: IAdminUserDetail;
}

function toAssignmentItem(partner: IAssignedPartner): AssignmentItem {
	return {
		profileId: partner.profileId,
		nickname: partner.nickname,
	};
}

export default function WorkerPartnersSection({ user }: WorkerPartnersSectionProps) {
	const [partners, setPartners] = useState<IAssignedPartner[]>(user.assignedPartners ?? []);
	const [loading, setLoading] = useState(!user.assignedPartners);
	const [saving, setSaving] = useState(false);

	const loadPartners = useCallback(async () => {
		setLoading(true);
		try {
			const data = await fetchAssignedPartners(user.id);
			setPartners(data);
		} finally {
			setLoading(false);
		}
	}, [user.id]);

	useEffect(() => {
		loadPartners();
	}, [loadPartners]);

	async function handleSave(nextItems: AssignmentItem[]) {
		setSaving(true);
		try {
			const updated = await putAssignedPartners(user.id, nextItems.map(item => item.profileId));
			setPartners(updated);
			toast.success('Список партнёров обновлён');
		} finally {
			setSaving(false);
		}
	}

	return (
		<UserAssignmentSection
			title='Прикреплён к партнёрам'
			emptyText='Воркер не прикреплён ни к одному партнёру.'
			items={partners.map(toAssignmentItem)}
			loading={loading}
			saving={saving}
			searchRole='partner'
			onSave={handleSave}
		/>
	);
}
